/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_765dd307"]'><div><cube-button @tap='(e)=>__invoke(e, [["showActionSheet"]])'>action-sheet-active</cube-button><cube-action-sheet ref="__mpx_ref_actionSheet__" title="我是标题~~~" :inputData="(inputData)" :active="(active)" @select='(e)=>__invoke(e, [["onSelect"]])' @cancel='(e)=>__invoke(e, [["onCancel"]])' @maskClose='(e)=>__invoke(e, [["onMaskClose"]])'/><cube-toast :txt="(selectContent)" ref="__mpx_ref_selectToast__"></cube-toast></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_765dd307"}'>
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_765dd307"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_765dd307"}
  /** script content **/
  require("./action-sheet-active.mpx.js?isComponent&outputPath=components%2Faction-sheet-active765dd307%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./action-sheet-active.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Faction-sheet-active765dd307%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_765dd307"],
    ctorType: "component",
    outputPath: "components/action-sheet-active765dd307/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-action-sheet':getComponent(require("../../../packages/mpx-cube-ui/src/components/action-sheet/index.mpx?isComponent&outputPath=components%2Findex51c8754f%2Findex")),'cube-toast':getComponent(require("../../../packages/mpx-cube-ui/src/components/toast/index.mpx?isComponent&outputPath=components%2Findex7b472558%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>